<template>
  <div id="zoomController">
    <div id="zoomButtonsContainer">
      <div
        id="zoomIn"
        class="zoomButton ripple"
        v-touch:tap="zoomIn"
      >+</div>
      <div
        id="zoomOut"
        class="zoomButton ripple"
        v-touch:tap="zoomOut"
      >-</div>
    </div>

    <div id="sliderContainer">
      <div
        id="handle"
        :style="`top: ${cursorPositionY}px`"
      ></div>
      <div id="shaft"></div>
    </div>

    <div
      id="warningContainer"
      v-if="zoomLevel !== 1"
    >
      <b-tooltip
        type="is-warning"
        :label="$t('tooltip.zoomWarning')"
        position="is-right"
      >
        <img
          id="warningPic"
          src="/static/warning.png"
          alt="⚠"
        >
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import interact from 'interactjs'
export default {
  name: 'ZoomButtons',
  data () {
    return {
      zoomedElement: null,
      zoomLevel: 1,
      cursorPositionY: 5
    }
  },
  mounted () {
    this.zoomedElement = document.querySelector('#mySpan')
    this.initInteractHanlde()
  },
  methods: {

    // https://interactjs.io/docs/
    initInteractHanlde () {
      interact(document.querySelector('#handle')).draggable({
        lockAxis: 'y', // Verrouille le déplacement en vertical uniquement
        modifiers: [
          interact.modifiers.snap({
            targets: [
              { x: 0, y: 12 }, // on commence en y 12 car la poignée fait 12px de diametre et est positionnée en top: 6px; zoom = 1
              { x: 0, y: 22 }, // après ça, chaque cran égal un dézoom de 0.1, donc zoom = 0.9
              { x: 0, y: 32 }, // zoom = 0.8
              { x: 0, y: 42 }, // zoom = 0.7
              { x: 0, y: 52 }, // zoom = 0.6
              { x: 0, y: 62 }, // zoom = 0.5
              { x: 0, y: 72 }, // zoom = 0.4
              { x: 0, y: 82 }, // zoom = 0.3
              { x: 0, y: 92 } // zoom = 0.2
            ],
            offset: 'parent'
          })
        ],
        onmove: (e) => { // quand la poigne bouge
          this.cursorPositionY += e.delta.y // on change la pos en y de la poignée par le delta (la 'différence'  entre la position de début et l'actuelle)
          this.zoomLevel = 1 - ((this.cursorPositionY - 10) / 90) // on adapte le zoomLevel
          this.zoomLevel = this.zoomLevel > 1 ? 1 : this.zoomLevel // on vérifie qu'il reste dans les marges voulues
          this.zoomLevel = this.zoomLevel <= 0.03 ? 0.1 : this.zoomLevel
          this.zoomedElement.style.transform = `scale(${this.zoomLevel})` // on modifie le zoom du board dans le DOM
        }

      })
    },
    zoomIn () {
      this.zoomLevel = this.zoomLevel < 1 ? this.zoomLevel + 0.1 : this.zoomLevel
      this.zoomLevel = this.zoomLevel > 1 ? 1 : this.zoomLevel
      this.zoomedElement.style.transform = `scale(${this.zoomLevel})`
      this.cursorPositionY = (1 - this.zoomLevel) * 90 + 10
    },
    zoomOut () {
      this.zoomLevel = this.zoomLevel - 0.1 < 0.11 ? this.zoomLevel : this.zoomLevel - 0.1 // we have to use 0.11 because the Float type sucks
      this.zoomLevel = this.zoomLevel <= 0.03 ? 0.1 : this.zoomLevel
      this.zoomedElement.style.transform = `scale(${this.zoomLevel})`
      this.cursorPositionY = (1 - this.zoomLevel) * 90 + 10
    },
    zoomReset () {
      this.zoomLevel = 1
      this.zoomedElement.style.transform = `scale(${this.zoomLevel})`
      this.cursorPositionY = (1 - this.zoomLevel) * 90 + 10
    }
  }
}
</script>

<style scoped>
#zoomController {
  display: flex;
  flex-flow: row nowrap;
  position: fixed;
  bottom: 200px;
}

#zoomButtonsContainer {
  width: 50px;
  height: 100px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}

.zoomButton {
  width: 30px;
  height: 40px;
  color: grey;
  background-color: white;
  margin: 0px auto;
  border: 1px solid lightgray;
  line-height: 1em;
  font-size: 2em;
  font-weight: bold;
  border-radius: 3px;
  box-shadow: 0px 0px 4px #00000054;
  cursor: pointer;
  user-select: none;
}

.ripple {
  background-position: center;
  transition: background 0.8s;
}
.ripple:hover {
  background: #fff radial-gradient(circle, transparent 1%, #fff 1%)
    center/15000%;
}
.ripple:active {
  background-color: #747474;
  background-size: 100%;
  transition: background 0s;
}

#zoomIn {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
#zoomOut {
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

#sliderContainer {
  background-color: #ffffff00;
  height: 100px;
  width: 30px;
  /* background-color: lime; */
}

#handle {
  background-color: white;
  cursor: grab;
  box-shadow: inset 0px 0px 2px 0.5px #8c8c8c;
  width: 12px;
  height: 12px;
  margin: auto;
  border-radius: 50%;
  position: relative;
  left: 0px;
  top: 6px;
  touch-action: none;
}

#shaft {
  background-color: white;
  box-shadow: inset 0px 0px 3px 1px #8c8c8c;
  height: 82px;
  width: 6px;
  margin: auto;
  border-radius: 5px;
}

#warningContainer {
  /* background-color: red; */
  position: absolute;
  bottom: 5px;
  right: -25px;
  height: min-content;
}

#warningPic {
  height: 25px;
  background-color: #ffffff75;
  padding: 3px;
  border-radius: 30px 30px 0px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/ZoomButtons.vue